import { useMemo, useRef } from "react";
import { useAppSelector } from "redux/hooks";
import { snakeCaseToSentenceCase } from "utils/formatText";
import { buildTextColumn } from "views/merchandise/columns/buildTextColumn";
import BulkActionsTable from "views/merchandise/tables/BulkActionsTable";
import ImageGenerationDialogue from "./ImageGenerationDialogue";
import { FaPencil } from "react-icons/fa6";

const PendingRequestsTable = ({ requestsData, isRequestsDataLoading, asin, productId }) => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const tableRef = useRef();

  const columns = useMemo(() => {
    return [
      buildTextColumn("state", "State", {
        formatter: (v) => {
          return snakeCaseToSentenceCase(v);
        },
        width: 150,
      }),
      buildTextColumn("prompt", "Prompt", {
        formatter: (v) => {
          return <span className="overflow-ellipsis">{v}</span>;
        },
        width: 500,
      }),
      {
        key: "actions",
        compareKey: null,
        options: {
          className: "text-start justify-content-start px-5 h-100",
          cellContainerClasses: "text-start justify-content-start",
          metric: {
            id: "actions",
            format: "text",
            accessor: (d) => d,
            name: "",
          },
          formatter: (v) => {
            const { theme_list, name, prompt } = v;
            const allThemeOptions = theme_list?.map((theme) => ({
              label: theme.themeForDisplay,
              value: theme.themeId,
            }));

            const initialFormData = { theme_list: allThemeOptions, name, prompt, additional_context: "" };

            return (
              <ImageGenerationDialogue
                asin={asin}
                productId={productId}
                overrideModalButtonText={<FaPencil style={{ fontSize: "14px", color: "#777" }} />}
                initialFormData={initialFormData}
              />
            );
          },
        },
      },
    ];
  }, [asin, productId]);

  return (
    <div>
      <BulkActionsTable
        marketPlace={marketPlace}
        isLoading={isRequestsDataLoading}
        tableRef={tableRef}
        hidePagination={true}
        tableId={"pendingImageGenerationRequestsTable"}
        titleCol={{
          id: "name",
          isStatic: true,
          Header: "Name",
          accessor: "name",
          style: { width: "450px" },
          width: 200,
          Cell: ({ row }) => {
            const { name } = row ?? {};

            return <div className="d-flex align-items-center overflow-ellipsis">{name ? name : "Unnamed"}</div>;
          },
          filterMethod: () => {
            return;
          },
          Filter: () => null,
        }}
        columnSpecs={columns}
        data={requestsData ?? []}
        bulkActionOptions={[]}
        isExpandable={false}
        hideFilterToggleIcon={true}
        isSelectable={false}
        selectionKey={"id"}
        getSearchCriteria={(row) => {
          const {
            advertisement: { name, id },
          } = row;
          return `${(name, id)}`;
        }}
        tableRowDescription={"Requests"}
        minRows={0}
      />
    </div>
  );
};

export default PendingRequestsTable;
